import { UiVariable } from 'pages/AutomationEngine/dialogs/VariableWizard/types';

import { TriggerStep } from './subsections/triggerSectionTypes';

import {
  activityLoggedInUse,
  removeActivityLoggedActivities,
  removeActivityPassedDueActivities,
  activityChanged,
  activityLoggedTriggerCount,
  activityPassedDueInUse,
  activityPastDueTriggerCount,
} from './subsections/ActivityLoggedGoal/variableHelpers';

export const checkTriggersInUseByVariable = (
  variables: UiVariable[],
  triggers: TriggerStep[],
  step: TriggerStep
) => {
  let inUse = false;
  let count = 0;
  switch (step.type) {
    case 'activity_logged':
      inUse = activityLoggedInUse(variables, step.details?.activity?.value);
      if (inUse) {
        count = activityLoggedTriggerCount(
          triggers,
          step.details?.activity?.value
        );
      }
      break;

    case 'scheduled_activity_overdue':
      inUse = activityPassedDueInUse(variables, step.details?.activity?.value);
      if (inUse) {
        count = activityPastDueTriggerCount(
          triggers,
          step.details?.activity?.value
        );
      }
      break;

    default:
      break;
  }
  return { inUse, count };
};

export const checkChangeInTrigger = (
  prevStep: TriggerStep,
  step: TriggerStep
) => {
  switch (step.type) {
    case 'activity_logged':
      return activityChanged(prevStep, step);

    case 'scheduled_activity_overdue':
      return activityChanged(prevStep, step);

    default:
      return false;
  }
};

export const removeInUseByTriggerType = (
  variables: UiVariable[],
  step: TriggerStep
) => {
  switch (step.type) {
    case 'activity_logged':
      return removeActivityLoggedActivities(
        variables,
        step.details?.activity?.value
      );

    case 'scheduled_activity_overdue':
      return removeActivityPassedDueActivities(
        variables,
        step.details?.activity?.value
      );

    default:
      return { variables, errorIds: [] };
  }
};
